import React from "react";
import { useNavigate } from "react-router";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";

function FooterPages() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <footer className="footer bg-light text-dark py-4 mt-5">
      <div className="container">
        <div className="row align-items-center">
          {/* Left Side */}
          <div className="col-md-8 col-sm-12 text-center text-md-start mb-3 mb-md-0">
            <img
              src="../Assets/Images/copyimg.webp"
              alt="Revenue Radar"
              className="img-fluid mb-2"
              style={{ maxHeight: "40px" }}
            />
            <p className="mb-0 small">
              <strong>© 2023 Quation Solutions Pvt. Ltd. — All rights reserved</strong>
            </p>
          </div>

          {/* Right Side */}
          <div className="col-md-4 col-sm-12 text-center text-md-end">
            <div className="d-flex justify-content-center justify-content-md-end gap-3">
              {/* Example Social Icons */}
              <a href="https://facebook.com" target="_blank" rel="noreferrer" className="text-primary">
                <i className="fab fa-facebook-f"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noreferrer" className="text-primary">
                <i className="fab fa-twitter"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-primary">
                <i className="fab fa-linkedin-in"></i>
              </a>
              <a href="#top" className="text-primary">
                <i className="fas fa-arrow-up"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default FooterPages;
